<template>
  <role-edit av-flow :admin="false" />
</template>

<script>
import RoleEdit from '../RoleEdit'
export default {
  components: { RoleEdit }
}
</script>

<style></style>
